import React, { useEffect, useRef, useState } from 'react';

const prefersReducedMotion = () =>
    typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

// Looping product demo. Plays only while on screen; with reduced motion it
// waits for the viewer to press play. Each demo also links to its shareable GIF.
const Demo = ({ demo, className = '' }) => {
    const ref = useRef(null);
    const [reduced] = useState(prefersReducedMotion);
    const base = `/media/${demo.name}`;

    useEffect(() => {
        const video = ref.current;
        if (!video || reduced || !('IntersectionObserver' in window)) return undefined;
        const io = new IntersectionObserver(
            ([entry]) => (entry.isIntersecting ? video.play().catch(() => {}) : video.pause()),
            { threshold: 0.35 },
        );
        io.observe(video);
        return () => io.disconnect();
    }, [reduced]);

    return (
        <figure className={`demo ${className}`}>
            <video
                ref={ref}
                src={`${base}.mp4`}
                poster={`${base}.jpg`}
                width={demo.width}
                height={demo.height}
                muted
                loop
                playsInline
                preload="metadata"
                controls={reduced}
                aria-label={demo.label}
            />
            <figcaption>
                <span>{demo.caption}</span>
                <span className="demo-links">
                    <a href={`${base}.mp4`} target="_blank" rel="noreferrer">Watch full size</a>
                    <a href={`${base}.gif`} download>Download GIF</a>
                </span>
            </figcaption>
        </figure>
    );
};

export default Demo;
